'use client';

import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';
import { Icon } from '@/components/atoms/Icon/Icon';
import { Icons } from '../Icon/icons';

const navLinkTypography: Record<string, string> = {
  sm: 'bodySm',
  md: 'body1',
  lg: 'bodyLgBold',
  xl: 'bodyXlBold',
};

const NavLinkContent = ({
  label,
  isNoChevron,
  isNoUnderline,
  leftIcon,
  leftIconType,
  onClick,
}: NavLinkProps) => {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: sp[8],
        minWidth: 0,
      }}
    >
      {leftIcon && <Icon icon={leftIcon} type={leftIconType} />}
      <div
        style={{
          minWidth: 0,
          textDecoration: !isNoUnderline ? 'underline' : '',
        }}
      >
        {label}
      </div>
      {!isNoChevron && <Icon icon='chevron-right' size={'xs'} />}
    </div>
  );
};

export interface NavLinkProps {
  className?: string;
  label?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  description?: string | ReactNode;
  isButton?: boolean;
  isNoChevron?: boolean;
  isNoUnderline?: boolean;
  leftIcon?: Icons;
  leftIconType?: 'fal' | 'fab';
  href?: string;
  children?: ReactNode;
  onClick?: () => void;
}
export const NavLink = ({
  className,
  size = 'md',
  isButton,
  description,
  href,
  children,
  ...props
}: NavLinkProps) => {
  return (
    <Box
      component='a'
      href={href}
      className={className}
      sx={{
        textDecoration: 'none',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        typography: navLinkTypography[size || 'sm'] || 'body1',
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      {isButton ? (
        <Box
          sx={{
            color: '#000000',
            background: '#f18b6c',
            p: sp[8],
            px: sp[16],
            borderRadius: sp[8],
            textAlign: 'center',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          <NavLinkContent {...props} />
        </Box>
      ) : (
        <NavLinkContent {...props} />
      )}
      {description && (
        <div style={{ textDecoration: 'none' }}>{description}</div>
      )}
      {children}
    </Box>
  );
};
